import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center p-8 text-center" data-testid="error-boundary">
        <h1 className="text-3xl">Something went wrong</h1>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">{String(this.state.error?.message ?? this.state.error)}</p>
        <button data-testid="error-boundary-reload" className="mt-6 h-12 rounded-full bg-primary px-6 font-bold text-white" onClick={() => window.location.assign("/")}>Back to LOVE NET</button>
      </div>
    );
  }
}
